import apiClient from '../api';

// export const updateUser = (data, id, header) => apiClient.put(`/user/update/${id}`, data, header);
export const getChatsByProjectId = (id, page, limit) => apiClient.get(`/chat/get/by/project/${id}?page=${page}&limit=${limit}`);

export const getSlackInvitationUrl = (data, id) => apiClient.post(`/slack/get/workspace/invitation/url/${id}`, data);